;(function (window, document) {
  if (!window || !document) return;

  var REGION = 'NA';
  var TAG_ID = '163e6858-4047-423d-95b7-8f9f55199284';
  var SCRIPT_ID = 'amzn-pixel';

  function ensureAmazonAds() {
    if (typeof window.amzn === 'function') {
      return window.amzn;
    }

    var amzn = function () {
      amzn.q.push([arguments, new Date().getTime()]);
    };

    amzn.q = [];
    amzn.version = '0.0';
    window.amzn = amzn;

    if (!document.getElementById(SCRIPT_ID)) {
      var script = document.createElement('script');
      var firstScript = document.getElementsByTagName('script')[0];

      script.src = 'https://c.amazon-adsystem.com/aat/amzn.js';
      script.id = SCRIPT_ID;
      script.async = true;

      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      } else {
        (document.head || document.body || document.documentElement).appendChild(script);
      }
    }

    amzn('setRegion', REGION);
    amzn('addTag', TAG_ID);

    return amzn;
  }

  function getCookie(name) {
    var escapedName = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    var match = document.cookie.match(new RegExp('(?:^|; )' + escapedName + '=([^;]*)'));

    return match ? match[1] : '';
  }

  function safeDecodeCookieValue(value) {
    if (!value) return '';

    try {
      return decodeURIComponent(value);
    } catch (error) {
      return value;
    }
  }

  function getAmazonConsentString() {
    var rawValue = getCookie('amzn_consent');

    if (!rawValue) return '';

    try {
      var decodedValue = safeDecodeCookieValue(rawValue);
      var data = JSON.parse(decodedValue);

      var countryCode = data && data.geo ? data.geo.countryCode || '' : '';
      var amazonConsentFormat = data && data.amazonConsentFormat ? data.amazonConsentFormat : {};

      var amznAdStorage = amazonConsentFormat.amznAdStorage || '';
      var amznUserData = amazonConsentFormat.amznUserData || '';

      // 你的规则：只要 countryCode 为空，就不上传
      if (!countryCode) return '';

      // 三个字段组成一个字符串
      return JSON.stringify({
        countryCode: countryCode,
        amznAdStorage: amznAdStorage,
        amznUserData: amznUserData,
      });
    } catch (error) {
      console.warn('[AmazonAds] parse amzn_consent failed', error);
      return '';
    }
  }

  async function getHashedEmail(email) {
    if (!email) return '';
    if (!window.crypto || !window.crypto.subtle) return '';

    var normalized = String(email).trim().toLowerCase();
    if (!normalized) return '';

    var data = new TextEncoder().encode(normalized);
    var hashBuffer = await window.crypto.subtle.digest('SHA-256', data);
    var hashArray = Array.prototype.slice.call(new Uint8Array(hashBuffer));

    return hashArray.map(function (b) {
      return b.toString(16).padStart(2, '0');
    }).join('');
  }

  async function trackEvent(eventName, payload) {
    if (!eventName) return false;

    try {
      var amazonConsentString = getAmazonConsentString();

      if (!amazonConsentString) {
        //console.warn('[AmazonAds] amazonConsentString is empty, skip event:', eventName);
        return false;
      }

      var finalPayload = Object.assign({}, payload || {}, {
        amazonConsentString: amazonConsentString,
      });

      var amzn = ensureAmazonAds();
      amzn('trackEvent', eventName, finalPayload);

      return true;
    } catch (error) {
      //console.warn('[AmazonAds] trackEvent failed', eventName, error);
      return false;
    }
  }

  async function trackNewsletterSubscribe(email) {
    var hashedEmail = await getHashedEmail(email);
    if (!hashedEmail) return false;

    return trackEvent('NewsletterSubscribe', {
      hashedEmail: hashedEmail,
    });
  }

  async function trackSpecialAwards(options) {
    var eventOptions = options || {};
    var hashedEmail = await getHashedEmail(eventOptions.email);

    if (!hashedEmail) return false;

    var payload = {
      hashedEmail: hashedEmail,
    };

    if (eventOptions.discountPercent !== undefined && eventOptions.discountPercent !== null && eventOptions.discountPercent !== '') {
      payload.discountPercent = eventOptions.discountPercent;
    }

    if (eventOptions.discountCode) {
      payload.discountCode = eventOptions.discountCode;
    }

    return trackEvent('SpecialAwards', payload);
  }

  window.RRAmazonAds = window.RRAmazonAds || {};
  window.RRAmazonAds.ensureAmazonAds = ensureAmazonAds;
  window.RRAmazonAds.getHashedEmail = getHashedEmail;
  window.RRAmazonAds.getAmazonConsentString = getAmazonConsentString;
  window.RRAmazonAds.trackEvent = trackEvent;
  window.RRAmazonAds.trackNewsletterSubscribe = trackNewsletterSubscribe;
  window.RRAmazonAds.trackSpecialAwards = trackSpecialAwards;

  ensureAmazonAds();
})(window, document);
